import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/viewer/src/ts/config";

/**
 * Specifies the total duration of the enter transition.
 */
const DURATION = 400;

type BlockTransitionProps = {
  children: React.ReactNode;

  /**
   * If enabled, the transition will be reversed (ie. running from left to
   * right rather than right to left).
   */
  reversed?: boolean;
};

/**
 * Simple transition that'll fade and slide blocks into view.
 */
// tslint:disable-next-line variable-name
export const BlockTransition: React.FC<BlockTransitionProps> = (props) => {
  const { children, reversed, ...restProps } = props;
  const className = `${
    reversed ? "blockTransition--reversed" : ""
  } blockTransition`.trim();

  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...restProps}
      timeout={{
        enter: DURATION,
        exit: 0,
      }}
      classNames={className}
      nodeRef={ref}
    >
      <div ref={ref}>
        {children}

        <style jsx global>{`
          .blockTransition-enter {
            opacity: 0;
            transform: translateX(100px);
          }

          .blockTransition--reversed.blockTransition-enter {
            transform: translateX(-100px);
          }

          .blockTransition-enter-active {
            opacity: 1;
            transform: translateX(0) !important;

            /** Apply transition curve */
            transition: opacity ${DURATION}ms linear,
              transform ${DURATION * 0.9}ms ${easings.inOutCubic};
          }

          .blockTransition-exit {
            /** Make sure exiting elements are hidden instantly */
            display: none;
          }
        `}</style>
      </div>
    </CSSTransition>
  );
};
